import type { Carer, Home } from '@lmc/ts-common'
import { Modal as PopupModal } from '@lmc/ui-kit'
import { Component, Suspense } from 'react'
import { connect } from 'react-redux'
import type { Action } from 'redux'
import Actions from '../../actions'
import { broadcastHomeSwitch } from '../../common/services/homeSwitchBroadcast'
import Operations from '../../operations'
import Field from '../fields'
import Modal from './index'

type SwitchHomeModalProps = {
  fields: { home: Home }
  user: Carer | string
  updateItem: (input: unknown) => void
  homes: Home[]
  isOpen: boolean
  close: () => void
}
type SwitchHomeModalState = {
  data: { homes: Home[] }
  global: { user: Carer }
}

export class SwitchHomeModal extends Component<
  SwitchHomeModalProps,
  SwitchHomeModalState
> {
  handleSubmit = () => {
    const {
      fields: { home },
      user,
      updateItem
    } = this.props

    updateItem({
      url: `list/carers/${user}`,
      json: { home },
      onComplete: this.handleComplete
    })
  }

  handleComplete = () => {
    const newHomeId = String(this.props.fields.home)
    const newHome = this.props.homes?.find((h) => h.id === newHomeId)
    broadcastHomeSwitch({ newHomeId, newHomeName: newHome?.name || '' })
    window.location.href = '/'
  }

  render() {
    const { homes, isOpen, fields, close } = this.props

    if (!isOpen || !homes) return null

    const homeOptions = homes.map((home) => ({
      label: home.name,
      value: home.id
    }))

    return (
      <PopupModal
        localisation={{
          title: 'Switch Site',
          confirmText: 'Switch',
          cancelText: 'Cancel'
        }}
        isModalVisible={isOpen}
        onConfirm={this.handleSubmit}
        onCancel={close}
        noPadding
        closeButton
      >
        <div style={styles.fieldContainer} data-cy="sites-container">
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formId={MODAL_ID}
              keys="home"
              layout="no-label"
              options={homeOptions}
              required
              type="radios"
              values={fields}
            />
          </Suspense>
        </div>
      </PopupModal>
    )
  }
}

const styles = {
  fieldContainer: {
    marginBottom: 20
  },
  modal: {
    overflow: 'visible'
  }
}

const MODAL_ID = 'switchHomeModal'

const mapStateToProps = (state: SwitchHomeModalState) => ({
  homes: state.data.homes,
  user: state.global.user.id
})

const mapDispatchToProps = (dispatch: (arg0: Action<unknown>) => void) => ({
  clearTodos: () => dispatch(Actions.clearTodos()),
  switchHome: (data: { home: Home }) => dispatch(Operations.switchHome(data))
})

const wrappedModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(SwitchHomeModal)

export default Modal(wrappedModal, MODAL_ID)
